import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getRouteApi } from '@tanstack/react-router';
import { SlidersHorizontal } from 'lucide-react';

import { badgeVariants } from '@/components/new-ui/badge';
import { cn } from '@/lib/utils';
import { Button } from '@/components/new-ui/button';

import { ESTATES_TOOLBAR_ROUTES } from '../constants/routes';
import { countActiveFilters } from './estates-filter-shared';

const route = getRouteApi(ESTATES_TOOLBAR_ROUTES.ESTATES);

/** Filters button of the estates page, toggles the filter drawer through the URL. */
export const EstatesFilterTrigger = () => {
  const { t } = useTranslation();
  const navigate = route.useNavigate();
  const search = route.useSearch();

  const { activeFiltersCount, enableFilters } = useMemo(
    () => ({
      activeFiltersCount: countActiveFilters(search.filters),
      enableFilters: Boolean(search.enableFilters),
    }),
    [search]
  );

  const switchEnableFilters = () => {
    navigate({
      search: (prev) => ({
        ...prev,
        enableFilters: 'enableFilters' in prev ? !prev.enableFilters : true,
      }),
      replace: true,
    });
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="relative gap-2"
      aria-label={t('filter')}
      aria-pressed={enableFilters}
      onClick={switchEnableFilters}
    >
      <SlidersHorizontal className="h-4 w-4" />
      <span className="hidden sm:inline">{t('filter')}</span>
      {/* span, not the Badge div, because a div is not allowed inside a button */}
      {activeFiltersCount > 0 ? (
        <span className={cn(badgeVariants({ variant: 'secondary' }), 'ml-1 h-5 min-w-5 px-1')}>
          {activeFiltersCount}
        </span>
      ) : null}
    </Button>
  );
};
